export class AnnouncementBarKite extends window.PURELEI.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.container.element.addEventListener('click', () => document.querySelector('a[data-drawers-trigger=cart]').click())
    this.onCartChange = this.onCartChange.bind(this)

    window.PURELEI.eventBus.addEventListener(
      window.PURELEI.EVENTS.PUSH_CART.CHANGED,
      this.onCartChange,
    )
  }

  onCartChange (event) {
    this.renderSection('announcement-bar-free-items')
  }

  async renderSection(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    const res = await fetch(url.toString(), { cache: 'no-store' });
    const html = await res.text();
    const target = this.els.container.element;

    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    const fresh = wrapper.querySelector(`[data-announcement-bar-kite-el=container]`);
    
    if (fresh)  {
        target.innerHTML = fresh.innerHTML;
        target.style.setProperty('--ProgressBar_Threshold', fresh.style.getPropertyValue('--ProgressBar_Threshold'));
        target.style.setProperty('--ProgressBar_Total', fresh.style.getPropertyValue('--ProgressBar_Total'));
    }
  }
}

if (!customElements.get('announcement-bar-kite')) {
  customElements.define('announcement-bar-kite', AnnouncementBarKite)
}
